import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
  OnInit,
  ComponentRef
} from '@angular/core';
import { BlockUIInstanceService } from '../../services/block-ui-instance.service';
import { BlockUIDefaultName } from '../../constants/block-ui-default-name.constant';

@Component({
  selector: 'block-ui',
  template: `
    <ng-content></ng-content>
    <block-ui-content
      [name]="name"
      [message]="message"
      [template]="template"
      [delayStart]="delayStart"
      [delayStop]="delayStop"
    >
    </block-ui-content>
  `,
  encapsulation: ViewEncapsulation.None,
  // Upstream declared no strategy. The published bundle was stamped Angular
  // 14.3.0, so the v22 linker gave it Eager; compiling it ourselves under v22
  // would silently make it OnPush. Pinned to keep behaviour identical (R1).
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BlockUIComponent implements OnInit {
  @Input() name: string;
  @Input() message: any;
  @Input() delayStart: number;
  @Input() delayStop: number;
  @Input() template: any;

  constructor(
    private blockUI: BlockUIInstanceService,
  ) { }

  ngOnInit() {
    this.name = this.name || BlockUIDefaultName;
    this.template = this.template || this.blockUI.blockUISettings.template;
  }
}
